import type { Vehicle } from '../types';

// Helper to add required BaseVehicle properties to mock data
const addVehicleDefaults = (vehicle: Omit<Vehicle, 'isActive' | 'createdAt' | 'updatedAt'>): Vehicle => ({
  ...vehicle,
  isActive: true,
  createdAt: '2025-01-01T00:00:00Z',
  updatedAt: '2025-01-30T00:00:00Z'
});

const rawVehicleData = [
  {
    id: 'uc-001',
    year: 2023,
    make: 'Honda',
    model: 'Accord',
    style: 'LX Sedan 4D',
    class: 'Mid-Size Car',
    productLine: 'usedCar' as const,
    values: {
      tradeIn: 28500,
      retail: 32000,
      wholesale: 26800,
      lastUpdated: '2025-01-30'
    },
    specs: {
      engine: '1.5L 4-Cylinder Turbo',
      transmission: 'CVT',
      drivetrain: 'FWD',
      fuelType: 'Gasoline',
      mpgCity: 32,
      mpgHighway: 42
    },
    imageUrl: '/images/vehicles/honda-accord-2023.jpg'
  },
  {
    id: 'uc-002', 
    year: 2022,
    make: 'Toyota',
    model: 'Camry',
    style: 'LE Sedan 4D',
    class: 'Mid-Size Car',
    productLine: 'usedCar' as const,
    values: {
      tradeIn: 26800,
      retail: 30200, 
      wholesale: 25200,
      lastUpdated: '2025-01-30'
    },
    specs: {
      engine: '2.5L 4-Cylinder',
      transmission: '8-Speed Automatic',
      drivetrain: 'FWD',
      fuelType: 'Gasoline',
      mpgCity: 28,
      mpgHighway: 39
    }
  },
  {
    id: 'uc-003',
    year: 2021,
    make: 'Ford',
    model: 'F-150',
    style: 'XLT SuperCrew 4D',
    class: 'Full-Size Pickup',
    productLine: 'usedCar' as const,
    values: {
      tradeIn: 38500,
      retail: 43200,
      wholesale: 36800,
      lastUpdated: '2025-01-30'
    },
    specs: {
      engine: '3.5L V6 EcoBoost',
      transmission: '10-Speed Automatic',
      drivetrain: '4WD',
      fuelType: 'Gasoline',
      mpgCity: 20,
      mpgHighway: 26
    }
  }
];

// Export the vehicle data with proper BaseVehicle properties
export const usedCarData: Vehicle[] = rawVehicleData.map(addVehicleDefaults);
export const mockVehicles: Vehicle[] = usedCarData; // Alias for compatibility

export const usedCarMakes = ['Honda', 'Toyota', 'Ford', 'Chevrolet', 'Nissan', 'BMW', 'Mercedes-Benz'];
export const usedCarClasses = ['Compact Car', 'Mid-Size Car', 'Full-Size Car', 'SUV', 'Pickup', 'Van'];
export const usedCarYears = Array.from({length: 15}, (_, i) => 2025 - i);